import React from "react";

//const ButtonBase = React.lazy(() => import('@stardust-ds/react/lib/esm/components/Button/button'));

import styles from "./index.module.scss"
import PlusIcon from "../../../assets/icons/PlusIcons"
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon"
import ArrowRightIcon from "../../../assets_v2/icons/ArrowRightIcon"
import CheckIcon from "../../../assets/icons/CheckIcon"
import PenDocumentIcon from "../../../assets/icons/PenDocument"
import RcmpAutomationIcon from "../../../assets_v2/icons/AutomationIcon"
import SearchIcon from "../../../assets/icons/SearchIcon"
import SaveIcon from "../../../assets_v2/icons/saveIcon"
const GetIcon = ({ icon, ...props }) => {
  switch (icon) {
    case "plus":
      return <PlusIcon stroke={props.iconColor} {...props} />
    case "arrowLeft":
      return <ArrowLeftIcon {...props} />
    case "arrowRight":
      return <ArrowRightIcon {...props} />
    case "check":
      return <CheckIcon {...props} />
    case "penDocumentIcon":
      return <PenDocumentIcon {...props} />
    case "RcmpAutomationIcon":
      return <RcmpAutomationIcon scale={"1.7"} {...props} />
    case "search":
      return <SearchIcon {...props} />
    case "save":
      return <SaveIcon {...props} />
    default:
      return icon || null
  }
}

export default function RcmpButton(props) {
  const {
    children,
    color = "main",
    filled = true,
    size = "large",
    className,
    iconLeft,
    iconRight,
    liquid = false,
    style,
    iconColor,
    colorsTheme,
    ...rest
  } = props

  const liquidWidth = !liquid ? { minWidth: 171 } : ""
  const classes = `${styles.buttonBase} ${colorsTheme ? styles.deparmentTheme : styles[color]} ${filled ? styles.filled : ""} ${styles[size]} ${className}`

  const setIconLeft = iconLeft ? <GetIcon icon={iconLeft} iconColor={iconColor} /> : null
  const setIconRight = iconRight ? <GetIcon icon={iconRight} iconColor={iconColor} /> : null

  const oButtonStyle = {
    ...(colorsTheme
      ? {
        "--primary-color": colorsTheme?.opc_cprimary_color,
        "--secondary-color": colorsTheme?.opc_csecondary_color,
      }
      : {}),
    ...liquidWidth,
    ...style,
  }

  return (
    <>{/*}
    <ButtonBase
      className={classes}
      iconLeft={setIconLeft}
      iconRight={setIconRight}
      style={oButtonStyle}
      {...rest}
    >
      {children} 
    </ButtonBase>*/}
    </>
  )
}
